import { css } from "styled-components";
import token from "styled-token";
import { StyledText } from "../../components/Text/Text";
import { spaceMixin } from "../spaceMixin";
import { typographyMixin } from "../typographyMixin";
import { PROPERTY_CARD_APPEARANCES } from "../../constants/PROPERTY_CARD";
/** @class PropertyCardMLSFooterMixin */

/** @method */

export var PropertyCardMLSFooterMixin = function PropertyCardMLSFooterMixin(props) {
  return token({
    background: "PropertyCard.mls.background",
    fontColor: "PropertyCard.mls.fontColor",
    fontType: "PropertyCard.mls.fontType." + PROPERTY_CARD_APPEARANCES.LARGE,
    fontWeight: "fontWeights.finePrintHeading",
    textShadow: "PropertyCard.mls.textShadow"
  }, function (_ref) {
    var background = _ref.background,
        fontColor = _ref.fontColor,
        fontType = _ref.fontType,
        fontWeight = _ref.fontWeight,
        textShadow = _ref.textShadow;
    return css(["align-items:end;background:", ";display:grid;grid-gap:", ";grid-template-columns:1fr min-content;padding:", " ", " ", " ", ";", "{", " font-weight:", ";color:", ";padding-bottom:", ";text-shadow:", ";}"], background, spaceMixin("xs")(props), spaceMixin("xs")(props), spaceMixin(0.5)(props), spaceMixin(0.5)(props), spaceMixin("xs")(props), StyledText, typographyMixin(Object.assign({
      fontColor: fontColor,
      fontType: fontType
    }, props)), fontWeight, fontColor, spaceMixin(0.25)(props), textShadow);
  })(props);
};